import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/commonReserveFundAssign/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/commonReserveFundAssign/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/commonReserveFundAssign/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/commonReserveFundAssign/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/commonReserveFundAssign/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/commonReserveFundAssign/delete',
      method: 'delete',
      params: data
    })
  }
}
